import {
  ISSUES_DASHBOARD_GROUP,
  ISSUES_SECTION_LABEL_ID,
} from 'charts/catalog/analyticsDashboardLayout';
import { isCatalogIssueChartId } from 'charts/constants/catalogIssueCharts';
import { useIssueAnalyticsCharts } from 'charts/hooks/useIssueAnalyticsCharts';
import { useIssueChartRuntime } from 'charts/hooks/issue/IssueChartRuntimeContext';
import { formatTranslation } from 'intl';
import React, { ReactElement, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { MemoAnalyticsChartGroup } from './AnalyticsChartGroup';
import { MemoSectionFilters } from '../sectionFilters/SectionFilters';
import { SectionFiltersProvider } from '../sectionFilters/SectionFiltersContext';
import { ISSUES_SECTION_FILTERS } from '../sectionFilters/sharedFilters';
import {
  toSectionCharts,
  useSectionSharedFilters,
} from '../sectionFilters/useSectionSharedFilters';
import { Typography } from '@mui/material';
import { domainHeadingSx } from './styles';

export function AnalyticsSectionIssues(): ReactElement | null {
  const intl = useIntl();
  const charts = useIssueAnalyticsCharts();
  const { runtimeById } = useIssueChartRuntime();
  const sectionCharts = useMemo(
    () => toSectionCharts(charts, runtimeById, isCatalogIssueChartId),
    [charts, runtimeById]
  );
  const sharedFilters = useSectionSharedFilters(
    sectionCharts,
    ISSUES_SECTION_FILTERS
  );

  if (charts.length === 0) {
    return null;
  }

  return (
    <section>
      <Typography component="h2" sx={domainHeadingSx}>
        {formatTranslation(intl, ISSUES_SECTION_LABEL_ID)}
      </Typography>
      <MemoSectionFilters model={sharedFilters} />
      <SectionFiltersProvider model={sharedFilters}>
        <MemoAnalyticsChartGroup
          sectionLabelId={ISSUES_DASHBOARD_GROUP.labelId}
          charts={charts}
          runtimeById={runtimeById}
          isChartId={isCatalogIssueChartId}
        />
      </SectionFiltersProvider>
    </section>
  );
}

export const MemoAnalyticsSectionIssues = React.memo(AnalyticsSectionIssues);
